import { OverlayTrigger, Popover, Text } from '@wyz/ui';
import { DateUtils } from '@wyz/utils';
import { Trans, useLocale } from '~/common/context';

type Props = {
  username?: string | null;
  updatedAt?: string | Date | null;
  heading?: 'xxs' | 'xs' | 'sm';
};

function UserCell({ username, updatedAt, heading = 'sm' }: Props) {
  const locale = useLocale();

  return (
    <OverlayTrigger
      trigger={['focus', 'hover']}
      placement='bottom'
      overlay={
        <Popover className='py-1 px-2'>
          <Text heading='xs'>{username}</Text>
          {updatedAt && (
            <Text heading='xs'>
              <Trans
                i18nKey='app.common.update_value'
                values={{
                  date: locale.formatters.date(new Date(updatedAt), {
                    format: DateUtils.DATE_FORMAT.DMY,
                  }),
                }}
              />
            </Text>
          )}
        </Popover>
      }
    >
      <Text weight='semi-bold' heading={heading} className='text-truncate'>
        {username}
      </Text>
    </OverlayTrigger>
  );
}

export default UserCell;
